import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { Box, Grid, Typography } from '@mui/material';

import { Dish, Option } from 'rdx/menu/scheme';
import { toUIAvailabilityStatus } from 'rdx/menu/utils';

interface MenuItemInfoProps {
  item: Dish | Option;
}

const MenuItemInfo: React.FC<MenuItemInfoProps> = ({ item }) => {
  const intl = useIntl();
  return (
    <Grid
      container
      columnSpacing={2}
      rowSpacing={2}
      sx={{ backgroundColor: 'colors.neutral100' }}
      p={1}
    >
      <Grid item xs={2}>
        <Typography variant="subtitleM">
          {intl.formatMessage({ id: 'widgets.MenuEditor.itemName' })}
        </Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography variant="bodyM">{item.name?.value}</Typography>
      </Grid>
      {item.description ? (
        <>
          <Grid item xs={2}>
            <Typography variant="subtitleM">
              {intl.formatMessage({ id: 'widgets.MenuEditor.description' })}
            </Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography variant="bodyM">{item.description?.value}</Typography>
          </Grid>
        </>
      ) : null}
      <Grid item xs={2}>
        <Typography variant="subtitleM">
          {intl.formatMessage({ id: 'widgets.MenuEditor.pricePlaceholder' })}
        </Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography variant="bodyM">{item.price?.price_str}</Typography>
      </Grid>
      {item.images &&
      item.images.menu_item_list_v1 &&
      item.images.menu_item_list_v1.aspect_ratio_map &&
      item.images.menu_item_list_v1.aspect_ratio_map.original ? (
        <>
          <Grid item xs={2}>
            <Typography variant="subtitleM">
              {intl.formatMessage({ id: 'widgets.MenuEditor.image' })}
            </Typography>
          </Grid>
          <Grid item xs={10}>
            <Box sx={{ maxWidth: 320, width: '100%', minHeight: 180 }}>
              <img
                src={item.images.menu_item_list_v1.aspect_ratio_map.original['1x']}
                alt={item.name?.value}
              />
            </Box>
          </Grid>
        </>
      ) : null}
      <Grid item xs={2}>
        <Typography variant="subtitleM">
          {intl.formatMessage({ id: 'widgets.MenuEditor.availabilitySubttile' })}
        </Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography variant="bodyM">
          {intl.formatMessage({
            id: `widgets.MenuEditor.${toUIAvailabilityStatus(item.availability)}`,
          })}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default memo(MenuItemInfo);
